export default function (initialDataInteractor, questionnaireId, questionOrder) {
  let questionnaire = initialDataInteractor.data.questionnaires.find(q => q.id == questionnaireId);

  let originalQuestionOrder = [];
  questionnaire.questions.forEach(q => originalQuestionOrder.push(q.id));

  let newQuestionOrder = [];
  questionOrder.forEach(q => newQuestionOrder.push(q));

  if (originalQuestionOrder.sort().join() === newQuestionOrder.sort().join()) {
    let newQuestions = [];

    questionOrder.forEach(id =>
      newQuestions.push(
        questionnaire.questions.find(q => q.id == id)
      )
    );

    questionnaire.questions = newQuestions;
  }
}
